import axiosIns from './axios';

const getRequest = (url, config, data = {}) => {
  return axiosIns
    .get(url, { params: data, ...(config || {}) })
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

const postRequest = (url, data, config) => {
  return axiosIns
    .post(url, data, config)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

const putRequest = (url, data) => {
  return axiosIns
    .put(url, data)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

const patchRequest = (url, data) => {
  return axiosIns
    .patch(url, data)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

const deleteRequest = (url, data, config = {}) => {
  return axiosIns
    .delete(url, { params: data, ...(config || {}) }, data)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export { getRequest, postRequest, putRequest, patchRequest, deleteRequest };
